import http from './httpService';

 

export const getVisits = async (page, perPage) => {
  const response = await http.get(`getvisits/?page=${page}&per_page=${perPage}`); // Correct endpoint
  return response.data;  
};  
         
export const getBeneficiaries = async () => {
  const response = await http.get(`get-Beneficiaries`); // Correct endpoint
  return response.data; 
}; 
export const getBeneficiariesWoman = async () => {
  const response = await http.get(`get-beneficiaries-woman`); // Correct endpoint
  return response.data; 
};      
       
 export const getPregnancyTrackingData = async () => {
  const response = await http.get(`getPregnancyTrackingData`); // Correct endpoint
  return response.data; 
};      
     


export const getHomeTodayCount = async () => {
  const response = await http.get('getHomeTodayCount'); // Correct endpoint
  return response.data; 
};      
 
export const getImmunizationTodayCount = async () => {
  const response = await http.get('getImmunizationTodayCount'); // Correct endpoint
  return response.data; 
};      

export const getReferralTodayCount = async () => {
  const response = await http.get('getReferralTodayCount'); // Correct endpoint
  return response.data; 
};      
 

  
export const getreferrals = async (page, perPage) => {
  const response = await http.get(`getreferrals?page=${page}&per_page=${perPage}`); // Correct endpoint
  return response.data; 


};      


export const deleteBeneficiary = async (beneficiary_id) => {
  const response = await http.get(`deleteBeneficiaryTree?beneficiary_id=${beneficiary_id}`); // Correct endpoint
  return response.data; // this will return { token, user }
};
  

export const getBeneficiaryTree = async (beneficiary_id) => {
  const response = await http.get(`getBeneficiariesTreeEdit?beneficiary_id=${beneficiary_id}`); // Correct endpoint
  return response.data; // this will return { token, user }
}; 
   

export const getBeneficiariesByTree = async (householdId,page) => {
  const response = await http.get(`getBeneficiariesTree?household_id=${householdId}&page=${page}`); // Correct endpoint
  return response.data; // this will return { token, user }
}; 

  
   

export const referralStore = async (data) => {
  const response = await http.post('/referral-store', data);
  return response.data; // this will return { token, user }
};


export const createPregnancy = async (data) => {
  const response = await http.post('/createPregnancy', data);
  return response.data; // this will return { token, user }
}; 

export const createAncVisit = async (data) => {
  const response = await http.post('/createAncVisit', data);
  return response.data; // this will return { token, user }
};
 

export const homeStore = async (data) => {
  const response = await http.post('/home-store', data);
  return response.data; // this will return { token, user }
};
 
export const createVHND = async (data) => {
  const response = await http.post('/vhnd/create', data);
  return response.data; // this will return { token, user }
};
  

 
export const getAllImmunization = async (page, perPage) => {
  const response = await http.get(`getAllImmunization?page=${page}&per_page=${perPage}`); // Correct endpoint
  return response.data; 
};  
export const getAllVHNDData = async (queryParams) => {
  const { page = 1, limit = 10, villageId: queryVillageId, location, duration, status } = queryParams;
 const response = await http.get('getAllVHNDData', {
      params: {
        page,
        limit, // Use 'limit' to match backend
        villageId: queryVillageId, // Fallback to villageId if queryVillageId is not provided
        location,
        duration,
        status,
      }, 
    });
  return response.data; 
};  


 
export const getHighRiskPregnancies = async (page, perPage) => {
  const response = await http.get(`getHighRiskPregnancies?page=${page}&per_page=${perPage}`); // Correct endpoint
  return response.data; 
};  

export const getActivePregnancy = async (page, perPage) => {
  const response = await http.get(`getActivePregnancy?page=${page}&per_page=${perPage}`); // Correct endpoint
  return response.data; 
};  

 
export const immunizationStore = async (data) => {
  const response = await http.post('/Immunization-store', data);
  return response.data; // this will return { token, user }
};



// Send OTP to the provided phone number
export const sendOTP = async ({ phoneNumber }) => {
  try {
    const response = await http.post('/send-otp', { phoneNumber });
    return response.data; 
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to send OTP');
  }
};


export const verifyOTP = async ({ phoneNumber, otp }) => {
  try {
    const response = await http.post('/verify-otp', { phoneNumber, otp });
    return response.data; 
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Invalid OTP');
  }
};

export const registerUser = async ({ fullName, contactNumber, aadharNumber, dateOfJoining, educationLevel, bankAccount }) => {
  try {
    const response = await http.post('/register-user', { 
      fullName,
      contactNumber,
      aadharNumber,
      dateOfJoining,
      educationLevel, 
      bankAccount,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Registration failed');
  }
};
                                          

export const verifyAadhaar = async ({ phoneNumber, aadhaar }) => {
  try {
    const response = await http.post('/verify-aadhaar', { phoneNumber, aadhaar });
    return response.data; 
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Aadhaar verification failed');
  } 
}; 
 

export const loginUser = async ({ phoneNumber, aadhaar }) => {
  try {
    const response = await http.post('/auth/login', { phoneNumber, aadhaar });
    return response; 
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Login failed');
  }
};

export const getVillages = async () => {
  try {
    const response = await http.get(`/get-villages`); 
    return response.data;    
  } catch (error) { 
    throw new Error(error.response?.data?.message || 'Failed to fetch villages');
  }
};  



export const getBeneficiaryStats = async () => {
  try {
      

    const response = await http.get(`/getBeneficiaryStats`);
    return response.data;
  } catch (error) { 
    throw new Error(error.response?.data?.message || 'Failed to fetch villages');
  }
};    

export const getBeneficiariesList = async ({ filters = {} }) => {
  try {
    const response = await http.get(`get-beneficiaries-list`, {
      params: {
        page: filters.page,
        limit: filters.limit, 
        search: filters.search, 
        category: filters.category,
        household: filters.household,
        sort: filters.sort,
      },
    });   

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch beneficiaries list');
  }
}; 
  

export const getBeneficiaryById = async (id) => {
  try {
    const response = await http.get(`/beneficiaries/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch beneficiary');
  }
};
export const getVillageByID = async (id) => {
  try {
    const response = await http.get(`/getVillageByID/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch beneficiary');
  }
};  



export const addBeneficiary = async (payload) => {
  try {
    const response = await http.post('/beneficiary-add', payload);
    return response.data; 
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to add beneficiary');
  }
};

export const updateBeneficiary = async (id, payload) => {
  try {
    const response = await http.put(`/update-beneficiary/${id}`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to update beneficiary');
  }
};
  

export const addBeneficiarytree = async (payload) => {
  try {
    const response = await http.post('/addBeneficiarytree', payload);
    return response.data; 
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to add beneficiary');
  }
};



